import React from 'react';
import RAGCircle from './RAGCircle';

const TRACK_LABEL = {
  classroom: 'Classroom',
  home: 'Home',
  core_skill: 'Core Skill',
  null: '—',
  undefined: '—',
};

const STATUS_LABEL = {
  green: 'Above expected',
  amber: 'Expected',
  red: 'Below expected',
  grey: 'Not attempted',
};

function AttemptHistory({ attempts, loading }) {
  if (loading) {
    return (
      <div className="py-4 flex items-center gap-2 text-sm text-gray-600">
        <span className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600" />
        <span>Loading attempts...</span>
      </div>
    );
  }

  if (!attempts || attempts.length === 0) {
    return <div className="py-3 text-sm text-gray-500">No attempts yet.</div>;
  }

  return (
    <div className="space-y-3 mt-3">
      {attempts.map((attempt) => {
        const attemptDate = attempt.completionDate
          ? new Date(attempt.completionDate).toLocaleDateString()
          : '—';
        const trackKey = String(attempt.track);
        const trackLabel = TRACK_LABEL[trackKey] ?? '—';

        return (
          <div
            key={attempt.submissionId ?? `${attempt.attemptNumber}-${attemptDate}`}
            className="group p-3 border border-gray-200/80 rounded-lg bg-white flex items-center justify-between gap-3 transition-all duration-200 ease-out hover:border-indigo-200 hover:bg-white hover:-translate-y-[1px] hover:shadow-[0_8px_20px_-14px_rgba(92,59,209,0.35)] motion-reduce:transform-none motion-reduce:transition-none"
          >
            <div className="flex flex-col text-sm">
              <span className="font-medium">Attempt {attempt.attemptNumber}</span>
              <span className="text-gray-600">Date: {attemptDate}</span>
              <span className="text-gray-600">Track: {trackLabel}</span>
              <span className="text-gray-600">
                Type: {attempt.isHomework ? 'Homework' : 'Lesson quiz'}
              </span>
              <span className="text-gray-600">
                Score:{' '}
                {attempt.percentScore === null || attempt.percentScore === undefined
                  ? '--'
                  : `${attempt.percentScore}%`}
              </span>
            </div>
            <RAGCircle
              statusBand={attempt.statusBand}
              statusLabel={STATUS_LABEL[attempt.statusBand] ?? 'Not attempted'}
              averagePercent={attempt.percentScore}
            />
          </div>
        );
      })}
    </div>
  );
}

export default AttemptHistory;
